<template>
	<el-drawer title="应用到其他组别" :visible.sync="dialogVisible" :modal-append-to-body="false" size="50%" direction="rtl" :wrapperClosable="false" >
		<div class="basis-page-cls apply-group">
			<div class="basis-cls_table">
					<table-pagination
					    ref="applyTable"
					    :data="list"
					    :column="column"
						@selection-change="handleSelectionChange" />
			 <div class="apply-group-footer">
				<el-button @click="dialogVisible = false" size="mini">取 消</el-button>
				<el-button type="primary" @click="onApplpy" size="mini" :loading="loading">{{ loading ? '提交中 ...' : '应 用' }}</el-button>
			 </div>
			</div>
		</div>
	</el-drawer>

</template>

<script>
	export default {
		props:['current_row'],
		data() {
			return {
				dialogVisible:false,
				listQuery: {
					brand:this.$store.state.user.brandId,
				},
				loading:false,
				list: [],
				column:[
					{ 
						label: '选择',
						prop: 'selection',
						type: 'selection',
						align:'left' ,
						selectable(row) {
							if (row.dataType && row.dataType == "不可操作") {
								return false;
							}
							return true;
						}
					},
					{
						label: '序号',
						width: 100,
						render: (h, scope) => {
							return <span>{(scope.$index + 1)}</span>
						}
					},
					{ label: '技能组ID', prop: 'groupId' },
					{ label: '技能组名称', prop: 'queueName' },
				],
				total: 1,
				disabled_data:[],
				multipleSelection: [],
				idKey: "queueName", // 标识列表数据中每一行的唯一键的名称(需要按自己的数据改一下)
			}
		},
		methods: {
			onApplpy(){
				if(this.multipleSelection.length == 0) {
					this.$notify.error('请先选择技能组');
					return;
				}
				this.loading = true;
				this.$api.apiCopyTelSkillgroupForSystem({
					brand: this.$store.state.user.brandId,
					newSkillGroup:this.multipleSelection.join(','),
					orgSkillGroup:this.current_row.skillGroup
				}).then(res => {
					this.loading = false;
					if(res.errcode != 0) return;
					this.$notify.success('操作成功');
					this.$emit('getList');
				})
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			openApply(){
				this.disabled_data = [];
				this.dialogVisible = true
				this.multipleSelection = []
				this.$nextTick(()=>{
					this.disabled_data.push({
						queueName:this.current_row.skillGroup
					})
					this.$refs.applyTable.$refs.elTable.clearSelection();
					this.getData()
				})
				
			},
			getData(){
				this.$api.apiGetTelSkillgroupForSystem({projectCode: this.$store.state.user.brandId}).then(response => {
				    if(response.errcode != 0) return;
					this.list = this.setDisabledLists(response.data);
				});
			},
			setDisabledLists(data){
				data.filter(item => {
					this.disabled_data.some(_item => {
						if (item[this.idKey] == _item[this.idKey]) {
							item.dataType = "不可操作";
						}
					});
				});
				return data
			},
		
			
		},
	}
</script>

<style lang="scss">
	.apply-group {
		padding: 20px;
		position: relative;
		.el-table .cell{
			height: 40px;
			line-height: 40px;
		}
	}
	.apply-group-footer {
		text-align: right;
		padding: 20px;
	}
</style>
